Postlogin = ((postlogin) => {
    postlogin.LessonAssignmentsList = {};
    const me = postlogin.LessonAssignmentsList;

    const assignmentsTable = $('#assignments-list-table');
    const lessonId = assignmentsTable.data('lesson-id');
    const exportUrl = $('#export-assignments').data('export-url');

    const initBootstrapTable = () => {
        assignmentsTable.bootstrapTable({
            formatNoMatches() {
                return 'No assignments to show';
            },
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'user_id',
            minimumCountColumns: '2',
            pagination: true,
            search: true,
            sortName: 'date_assigned',
            sortOrder: 'desc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            searchAlign: 'left',
            clickToSelect: true,
            maintainMetaData: true,
            maintainSelected: true,
            sidePagination: 'server',
            url: `/lessons/${lessonId}/assignments/json/`,
            pageSize: 25,
            queryParamsType: '',
            queryParams(params) {
                const startDate = document.getElementById('search-start-date').value;
                const endDate = document.getElementById('search-end-date').value;

                return {
                    ...params,
                    date_range_from: startDate,
                    date_range_to: endDate,
                };
            },
            columns: [
                {
                    checkbox: true,
                    checkboxEnabled: true,
                    field: 'checkbox',
                    visible: false,
                },
                {
                    title: 'Assigned',
                    field: 'date_assigned',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value) {
                        return new Date(value).toLocaleDateString('en-US', { timeZone: 'UTC' });
                    },
                },
                {
                    title: 'Start',
                    field: 'date_start',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value) {
                        return new Date(value).toLocaleDateString('en-US', { timeZone: 'UTC' });
                    },
                },
                {
                    title: 'Assigned By',
                    field: 'full_name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Grades',
                    field: 'grade_band',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: 'Subtitle',
                    field: 'subtitle',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Completion Type',
                    field: 'completion_type',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Assigned To',
                    field: 'users_count',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        const assignmentViewUrl = assignmentsTable
                            .data('view-url')
                            .replace(':lesson_id', row.lesson_id)
                            .replace(':assignment_id', row.assignment_id);

                        return `
                            <a href="${assignmentViewUrl}" class="btn btn-hollow-dark-gray">
                                ${value} ${parseInt(value, 10) === 1 ? 'student' : 'students'}
                            </a>
                        `;
                    },
                },
                {
                    title: '% Completed',
                    field: 'percentage_completed',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value) {
                        return `${Math.round(value * 100) / 100}%`;
                    },
                },
                {
                    title: ' ',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    formatter(value, row) {
                        const assignmentViewUrl = assignmentsTable
                            .data('view-url')
                            .replace(':lesson_id', row.lesson_id)
                            .replace(':assignment_id', row.assignment_id);
                        const assignmentEditUrl = row.locked === '1'
                            ? '#'
                            : assignmentsTable
                                .data('edit-url')
                                .replace(':lesson_id', row.lesson_id)
                                .replace(':assignment_id', row.assignment_id);
                        const assignmentDeleteUrl = assignmentsTable
                            .data('delete-url')
                            .replace(':lesson_id', row.lesson_id)
                            .replace(':assignment_id', row.assignment_id);

                        const lockedButtonAttributes = row.locked === '1'
                            ? 'disabled title="This assignment cannot be edited because it is being managed automatically."'
                            : '';

                        const manageActions = `
                            <a href="${assignmentEditUrl}" class="btn btn-hollow-blue" ${lockedButtonAttributes}>Edit</a>
                            <form action="${assignmentDeleteUrl}" method="post" class="delete-entry">
                                <input type="hidden" name="csrf_token" value="${Jr.getCsrfToken()}">
                                <input type="hidden" name="_METHOD" value="DELETE" />
                                <button type="submit" class="btn btn-hollow-pink" ${lockedButtonAttributes}>Delete</button>
                            </form>
                        `;

                        const additionalActions = +row.can_manage === 1 ? manageActions : '';

                        return `
                            <a href="${assignmentViewUrl}" class="btn btn-hollow-green">View</a>
                            ${additionalActions}
                        `;
                    },
                },
            ],
            responseHandler(res) {
                const results = {};
                results.total = res.meta.total;
                results.rows = res.data;

                return results;
            },
            onLoadSuccess() {
                $('time.timeago').timeago();
            },
            rowStyle(row) {
                let classes = '';

                if (row.percentage_complete < 33.3333) {
                    classes += 'danger ';
                } else if (row.percentage_complete < 66.6666) {
                    classes += 'warning ';
                } else if (row.percentage_complete < 100) {
                    classes += 'info ';
                } else {
                    classes += 'success ';
                }

                return {
                    classes,
                };
            },
            onCheck() {
                $('#bulk-delete-action-btn').attr('disabled', false);
            },
            onCheckAll() {
                $('#bulk-delete-action-btn').attr('disabled', false);
            },
            onUncheck() {
                if (assignmentsTable.bootstrapTable('getSelections').length > 0) {
                    $('#bulk-delete-action-btn').attr('disabled', false);
                } else {
                    $('#bulk-delete-action-btn').attr('disabled', true);
                }
            },
            onUncheckAll() {
                $('#bulk-delete-action-btn').attr('disabled', true);
            },
        });
    };

    const initEvents = () => {
        const today = new Date();
        const minDate = new Date(today.getFullYear() - 6, today.getMonth(), today.getDate());

        const dateOptions = {
            display: {
                theme: 'light',
                components: {
                    clock: false,
                },
            },
            localization: {
                format: 'L',
            },
            restrictions: {
                maxDate: today,
                minDate,
            },
        };

        const startDatePicker = new tempusDominus.TempusDominus(document.getElementById('search-start-date'), {
            ...dateOptions,
            container: document.getElementById('start-date-container'),
        });
        const endDatePicker = new tempusDominus.TempusDominus(document.getElementById('search-end-date'), {
            ...dateOptions,
            container: document.getElementById('end-date-container'),
        });

        startDatePicker.dates.setValue(startDatePicker.dates.parseInput(minDate));
        endDatePicker.dates.setValue(endDatePicker.dates.parseInput(today));

        $('#search-start-date').on('change', () => {
            assignmentsTable.bootstrapTable('refresh');
        });
        $('#search-end-date').on('change', () => {
            assignmentsTable.bootstrapTable('refresh');
        });

        $('#export-assignments').on('click', (event) => {
            event.preventDefault();
            const opts = assignmentsTable.bootstrapTable('getOptions');
            const startDate = document.getElementById('search-start-date').value;
            const endDate = document.getElementById('search-end-date').value;

            const exportParams = {
                columns: _.map(assignmentsTable.bootstrapTable('getVisibleColumns'), (col) => [col.title, col.field]),
                offset: 0,
                sort: opts.sortName,
                order: opts.sortOrder,
                date_range_from: startDate,
                date_range_to: endDate,
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                searchText: opts.searchText,
            };

            const queryString = $.param(exportParams);
            window.open(`${exportUrl}?${queryString}`, '_blank');
        });

        $('#bulk-delete-btn').on('click', () => {
            if (assignmentsTable.bootstrapTable('getHiddenColumns').length === 0) {
                cancelBulkDeleteMode();
            } else {
                startBulkDeleteMode();
            }
        });
        $('#bulk-delete-action-btn').on('click', () => {
            handleBulkDeleteAction();
        });
    };

    const startBulkDeleteMode = () => {
        assignmentsTable.bootstrapTable('showColumn', 'checkbox');
        $('#bulk-delete-btn').text('Cancel Bulk Delete');
        $('#bulk-delete-action-btn').removeClass('hidden');
    };

    const cancelBulkDeleteMode = () => {
        assignmentsTable.bootstrapTable('hideColumn', 'checkbox');
        $('#bulk-delete-btn').text('Bulk Delete Mode');
        $('#bulk-delete-action-btn').addClass('hidden');
    };

    const handleBulkDeleteAction = () => {
        const selections = assignmentsTable.bootstrapTable('getSelections');

        if (selections.length > 0) {
            const currentUserId = assignmentsTable.attr('data-current-user-id');
            const assignments = JSON.stringify(selections.map((i) => ({ assignment_id: i.assignment_id, lesson_id: i.lesson_id })));
            const url = `/users/${currentUserId}/lesson-assignments/bulk-delete/`;
            $.post(url, { assignments }, (data) => {
                const notificationParams = {
                    text: data.data.message,
                    time: 3000,
                    type: data.status,
                };

                VjsUtility.Notification.init(notificationParams);
                $('#bulk-delete-action-btn').attr('disabled', true);
                assignmentsTable.bootstrapTable('refresh');
            });
        }
    };

    me.init = () => {
        initEvents();
        initBootstrapTable();
    };

    return postlogin;
})(Postlogin || {});
